import React, { useEffect, useState } from 'react';
import './SettingsPopup.css'; // Make sure to link the CSS file
import './PricePopup.css'; // Make sure to link the CSS file
import { useUserAuth } from "../context/UserAuthContext";
import ProductComponent from './checkout/ProductComponent';
import blackcheck from './images/black-check.png'
import yelloarrow from './images/yello-arrow.png'
import Loading from 'react-loading-components';
import ConfirmDialog from './ConfirmDialog';

let subscriptionID = null;
let renewPaymentUrl = null;
let currnetPlanVariantID = null;

const PricePopup = ({ isVisible, onClose }) => {
  // Placeholder for handling input changes
  const { userDataLocal, userVipLevel, purchaseBtnClicked, setPurchaseBtnClicked, purchaseURLCreated, setPurchaseURLCreated, downgradeToFreeUser} = useUserAuth();
  const [userInfo, setUserInfo] = useState(userDataLocal);
  const [isVisiblePricePopup, setIsVisiblePricePopup] = useState(false);
  const [isAnnualBilling, setIsAnnualBilling] = useState(false);
  const { handlePurchaseAction, netErro, setNetErro, popupBlocked, setPopupBlocked } = ProductComponent();
  const [vipLevelString, setVipLevelString] = useState('Free User');
  const [upgradeBtnTitle, setUpgradeBtnTitle] = useState('Get Nvoice VIP');
  const [isLoadingVIP, setIsLoadingVIP] = useState(false);
  const [isLoadingBusiness, setIsLoadingBusiness] = useState(false);
  const [isLoadingFree, setIsLoadingFree] = useState(false);
  const [buyORCancel, setBuyORCancel] = useState(true);

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState(null);

  const [vipBtnTitle, setVipBtnTitle] = useState('Choose VIP');


  let VIPID = process.env.REACT_APP_LEMON_SQUEEZY_VIP_ID
  let VIP_VARIANT_ID = process.env.REACT_APP_LEMON_SQUEEZY_VIP_VARIANT_ID
  let VIP1ID = process.env.REACT_APP_LEMON_SQUEEZY_VIP1_ID
  let VIP1MonthlyID = process.env.REACT_APP_LEMON_SQUEEZY_VIP1_MONTHLY_ID
  let VIP1MonthlyPrice = process.env.REACT_APP_LEMON_SQUEEZY_VIP1_MONTHLY_PRICE
  let VIP1AnnualID = process.env.REACT_APP_LEMON_SQUEEZY_VIP1_ANNUALID
  let VIP1AnnualPrice = process.env.REACT_APP_LEMON_SQUEEZY_VIP1_ANNUAL_PRICE
  let VIP2ID = process.env.REACT_APP_LEMON_SQUEEZY_VIP2_ID
  let VIP2MonthlyID = process.env.REACT_APP_LEMON_SQUEEZY_VIP2_MONTHLY_ID
  let VIP2MonthlyPrice = process.env.REACT_APP_LEMON_SQUEEZY_VIP2_MONTHLY_PRICE
  let VIP2AnnualID = process.env.REACT_APP_LEMON_SQUEEZY_VIP2_ANNUAL_ID
  let VIP2AnnualPrice = process.env.REACT_APP_LEMON_SQUEEZY_VIP2_ANNUAL_PRICE
  let maxDiscount = (Number(VIP2MonthlyPrice) - Number(VIP2AnnualPrice)) / Number(VIP2MonthlyPrice) * 100;
  maxDiscount = maxDiscount.toFixed(0) + '%';



  useEffect(() => {
    setIsVisiblePricePopup(true);
    return () => {
    setIsVisiblePricePopup(false);
    };
  }, []);

  useEffect(() => {
    if (userDataLocal.VIPLevel > 0 && userDataLocal.VIPLevel <= 3){
      let purchaseHistoryArray = userDataLocal?.Purchasehistory || null;
      if(!purchaseHistoryArray) {
        console.error('no purchase history');
      } else {
        let newestPurchasedHistory = purchaseHistoryArray.slice(-1)[0]; //use the newest purchase history
        subscriptionID = newestPurchasedHistory.SubscriptionDetailBody.data.id;
        // console.log('subscriptionID:', subscriptionID);
        currnetPlanVariantID = newestPurchasedHistory.SubscriptionDetailBody.data.attributes.variant_id.toString();
        renewPaymentUrl = newestPurchasedHistory.SubscriptionDetailBody.data.attributes.urls.update_payment_method;
      }
      if (userDataLocal.VIPLevel > 0){
        setVipLevelString('VIP');
        // setUpgradeBtnTitle('Upgrade to Business');
        setUpgradeBtnTitle('Renew payment');
        setVipBtnTitle('Renew payment');
        if(currnetPlanVariantID){
          if (currnetPlanVariantID === VIP1MonthlyID){
            setVipLevelString('VIP monthly');
          } else if(currnetPlanVariantID === VIP1AnnualID){
            setVipLevelString('VIP annual');
          }
        }
      } else {
        setVipLevelString('Free User');
        setUpgradeBtnTitle('Get Nvoice VIP');
        setVipBtnTitle('Choose VIP');
      }
      // else if (userDataLocal.VIPLevel === 2){
      //   setVipLevelString('Business VIP');
      //   setUpgradeBtnTitle('Renew payment');
      // }
      // setVipLevelString(`VIP${userVipLevel}`);
    } 
  }, [userVipLevel]);


  useEffect(() => {
    if (purchaseURLCreated && !netErro && !popupBlocked){
      if (!purchaseBtnClicked) setPurchaseBtnClicked(true);
      setIsLoadingVIP(false);
      setIsLoadingBusiness(false);
      setPurchaseURLCreated(false);
      setIsLoadingFree(false);
    } 
  }, [purchaseURLCreated]);

  useEffect(() => {
    if (downgradeToFreeUser && !netErro && !buyORCancel){
      setIsLoadingVIP(false);
      setIsLoadingBusiness(false);
      setIsLoadingFree(false);
      alert('Auto-renewal of your current subscription has been canceled.');
    } else if (!downgradeToFreeUser && netErro && !buyORCancel) {
      alert('Network erro, please try again later.');
      setNetErro(false);
    }
  }, [downgradeToFreeUser]);

  useEffect(() => {
    if (netErro || popupBlocked){
      setIsLoadingVIP(false);
      setIsLoadingBusiness(false);
      setIsLoadingFree(false);
      if (popupBlocked) {
        alert('Error during purchase: Popup blocked, please enable popup for Nvoice.');
        setPopupBlocked(false)
      } else if(netErro) {
        alert('Network erro, please try again later.');
        setNetErro(false);
      }
      setIsLoadingVIP(false);
      setIsLoadingBusiness(false);
      setIsLoadingFree(false);
    }
  }, [netErro, popupBlocked]);

  useEffect(() => {
    if(currnetPlanVariantID){
      if (currnetPlanVariantID === VIP1MonthlyID || currnetPlanVariantID === '527641' || currnetPlanVariantID === '347671' || currnetPlanVariantID === '347681'){
        if (isAnnualBilling) {
          setUpgradeBtnTitle('Switch Plan');
          setVipBtnTitle('Yearly Plan');
        } else {
          setUpgradeBtnTitle('Renew payment');
          setVipBtnTitle('Renew payment');
        }
      } else if(currnetPlanVariantID === VIP1AnnualID || currnetPlanVariantID === '347672' || currnetPlanVariantID === '347682'){
        if (isAnnualBilling) {
          setUpgradeBtnTitle('Renew payment');
          setVipBtnTitle('Renew payment');
        } else {
          setUpgradeBtnTitle('Switch Plan');
          setVipBtnTitle('Monthly Plan');
        }
      }
    }
  }, [isAnnualBilling]);



  const checkUserLevel = (purchaseID) => {
    if(userDataLocal.VIPLevel === 0) {
      if(purchaseID === 'FREE') {
        return false;
      } else {
        return true;
      }
    } else if(userDataLocal.VIPLevel > 0) {
      
      if(purchaseID === 'FREE') {
        return true;
      } else {
        let purchaseHistoryArray = userDataLocal?.Purchasehistory || null;
        if(!purchaseHistoryArray) {
          console.error('no purchase history');
          return false;
        } else {
        // const currentPlanVariantName = body.data.attributes.variant_name;
        // if(purchaseID === currnetPlanVariantID) {
          // console.log('purchaseID === currnetPlanVariantID, they are the same id:', purchaseID, currnetPlanVariantID)
          return true;
        // }
        }
      }
    }
  }

  const toggleBilling = () => {
    setIsAnnualBilling(!isAnnualBilling);
  };

  //2024.09.18 
  const handleConfirmClose = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleConfirm = () => {
    if (confirmAction) {
      confirmAction();
    }
    setIsConfirmDialogOpen(false);
  };

  const handleDownToFreeAction = (priceAction, productId) => {
    if (productId === 'FREE') {
      setConfirmMessage('Are you sure you want to cancel your current subscription?');
      setConfirmAction(() => () => {
        setIsLoadingFree(true);
        setIsLoadingVIP(false);
        setIsLoadingBusiness(false);
        if (subscriptionID) {
          let purchaseID = subscriptionID;
          handlePurchaseAction(priceAction, purchaseID);
        }
      });
      setIsConfirmDialogOpen(true);
    } 
  }

  const buyProduct1 = async (productId) => {
    let purchaseID = productId;
    let priceAction = 'purchase'; //maybe later we can add refund feature
    if (productId === VIP1ID) {
      if (isAnnualBilling) {
        purchaseID = VIP1AnnualID;
      } else {
        purchaseID = VIP1MonthlyID;
      }
      if(userVipLevel > 0) {
        if(currnetPlanVariantID){
          if (currnetPlanVariantID === VIP1MonthlyID || currnetPlanVariantID === '527641' || currnetPlanVariantID === '347671' || currnetPlanVariantID === '347681'){
            if (isAnnualBilling) {
              priceAction = 'purchase'; //switchToYearly
            } else {
              priceAction = 'renewPayment';
            }
          } else if(currnetPlanVariantID === VIP1AnnualID || currnetPlanVariantID === '347672' || currnetPlanVariantID === '347682'){
            if (isAnnualBilling) {
              priceAction = 'renewPayment';
            } else {
              priceAction = 'purchase'; //switchToMonthly
            }
          }
        }
      }
    } else if(productId === 'FREE') {
      priceAction = 'downToFree';
    }
    // } else if (productId === VIP2ID) {
    //   if (isAnnualBilling) {
    //     purchaseID = VIP2AnnualID;
    //   } else {
    //     purchaseID = VIP2MonthlyID;
    //   }
    // } 


    if(checkUserLevel(purchaseID)) {
      // if (productId === VIP1ID) {
      if(productId === VIP1ID) {
        setIsLoadingVIP(true);
        setIsLoadingBusiness(false);
        setIsLoadingFree(false);
        let purchaseHistoryArray = userDataLocal?.Purchasehistory || null;
        let status = null;
        if(!purchaseHistoryArray) {
          console.error('no purchase history');
        } else {
          let newestPurchasedHistory = purchaseHistoryArray.slice(-1)[0]; //use the newest purchase history
          status = newestPurchasedHistory.SubscriptionDetailBody.data.attributes.status;
        } 
        if(userVipLevel > 0 && status === 'active' && priceAction === 'renewPayment') {
          //if current user is VIP, handle renew payment
          let purchaseID = subscriptionID;
          handlePurchaseAction(priceAction, purchaseID);
          // console.log('renew payment, purchaseID:', purchaseID);
        } else {
          //if current user is Free or VIP that user cancel auto renew it, handle purchase vip action
          priceAction = 'purchase';
          handlePurchaseAction(priceAction, purchaseID);
          // console.log('purchase payment, purchaseID:', purchaseID);
        } 
      } 
      // else if (productId === VIP2ID) {
      //   setIsLoadingBusiness(true);
      //   setIsLoadingVIP(false)
      //   setIsLoadingFree(false);
      //   handlePurchaseAction(priceAction, purchaseID);
      // } 
      else if(productId === 'FREE') {
        handleDownToFreeAction(priceAction, purchaseID);
        // handlePurchase(priceAction, productId);
        // const userConfirmed = confirm('Are you sure you want to cancel your current subscription?');
        // if (userConfirmed) {
        //   setIsLoadingFree(true);
        //   setIsLoadingVIP(false);
        //   setIsLoadingBusiness(false);
        //   if(subscriptionID) {
        //     purchaseID = subscriptionID;
        //     handlePurchaseAction(priceAction, purchaseID);
        //   }
        // } else {
        //   setIsLoadingVIP(false);
        //   setIsLoadingBusiness(false);
        //   setIsLoadingFree(false);
        // }
      }
      
    } else {
      //if user choice the product same as current plan, show alert
      alert('Sorry, you have already purchased this plan.');
      setTimeout(() => {
        setIsLoadingVIP(false);
        setIsLoadingBusiness(false);
        setIsLoadingFree(false);
      } , 50);
    }
  };

  const clickVIP = () => {
    // setIsLoadingVIP(true);
    // setIsLoadingBusiness(false);
    setBuyORCancel(true);
    buyProduct1(VIP1ID);
  }

  const clickBusiness = () => {
    // setIsLoadingBusiness(true);
    // setIsLoadingVIP(false)
    setBuyORCancel(true);
    buyProduct1(VIP2ID);
  }

  const clickFree = () => {
    setBuyORCancel(false);
    buyProduct1('FREE');
  }

  const free = [
    "30 minutes usage time",
    "5 minute per recording",
    "Language switch",
    "Note history",
    "AI response",
  ];
  // const vip1 = [
  //   "1000 minutes usage time",
  //   "Language switch",
  //   "Note history",
  //   "Downloadable audio",
  //   "Downloadable notes",
  //   "AI response",
  //   "AI wake-up keyword setting",
  //   "GPT version selection",
  //   "Note style customization",
  //   "Speaker identification",
  // ];

  const vip1 = [
    "1000 minutes usage time",
    "6 hours per recording",
    "Timestamp generation",
    "Language switch",
    "Note history",
    "Downloadable audio",
    "Downloadable notes",
    "AI response",
    "AI wake-up keyword setting",
    "GPT prompt customization",
    "Speaker identification",
    "Upload audio files",
    // "Voice intercom",
  ];

  const vip2 = [
    "6000 minutes usage time",
    "Language switch",
    "Note history",
    "Downloadable audio",
    "Downloadable notes",
    "AI response",
    "AI wake-up keyword setting",
    "Multimodal interaction with AI",
    "GPT version selection",
    "GPT prompt customization",
    "Note style customization",
    "Speaker identification",
    "Upload audio files",
    "Voice intercom",
  ];


  return (

    <div className={`popup-settingsnew-overlay ${isVisiblePricePopup ? 'active' : ''}`}>
      <div className="popup-price">

        <div className="popup-price-header">
          <p className="headtext">{upgradeBtnTitle}</p>
          <span className="close-price" onClick={onClose}>&times;</span>
        </div>

        <div className="popup-price-body">
          <div className="group">
            <div className="Bill">
              <div className="div-_text">
                <p className="billed">Billed Monthly</p>
              </div>
              <label className="switch">
                <input type="checkbox" checked={isAnnualBilling} onChange={toggleBilling} />
                <span className="slider"></span>
              </label>
              <div className="div-_text">
                <p className="billed">Billed Annually</p>
              </div>
              <div className="div-_cut-_tip">
                <img
                  src={yelloarrow}
                  alt="Not Found"
                  className="icon"
                />
                <p className="save">save up to {maxDiscount}</p>
              </div>
            </div>
            <div className="div-_list">
              <div className="div-_listitem">
                <p className="Text">FREE</p>
                <div className="div-_price1">
                  <p className="price">$0</p>
                  <p className="mo">/mo</p>
                </div>
                {/* <div className="div-_select-_btnfree">
                  <p className="choose-free">Choose Free</p>
                </div> */}
                <button
                  className={isLoadingFree ? "div-_select-_btn_clicked":"div-_select-_btn"}
                  onClick={clickFree}
                  // aria-hidden={isLoadingFree ? "true" : "false"}
                  // inert={isLoadingFree ? "true" : "false"}
                >
                  {isLoadingFree ? <Loading type='bars' width={100} height={50} padding={3} fill='#ffffff' /> : <div className="choose-business">Choose Free</div>}
                </button>

                <div className="div-_feature-_list">
                  {free.map((feature, index) => (
                    <div key={index} className="div-_featureitem">
                      <img
                        src={blackcheck}
                        alt="Feature Icon"
                        className={`icon-`}
                      />
                      <p className={`feature-text-`}>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="div-_listitem">
                <p className="Text">VIP</p>
                <div className="div-_price1">
                  <p className="price">{isAnnualBilling ? `$${VIP1AnnualPrice}` : `$${VIP1MonthlyPrice}`}</p>
                  {/* <p className="price">${VIP1MonthlyPrice}</p>
                  <p className="mo">/mo</p> */}
                  {isAnnualBilling ? (
                    <div>
                      <div className="div-_unit">
                        <div className="span-_cut">
                          <p className="discont">{`$${VIP1MonthlyPrice}`}</p>
                        </div>
                      </div>
                      <p className="mo">/mo</p>
                    </div>
                  ) : (
                    <p className="mo">/mo</p>
                  )}
                </div>

                <button
                  className={isLoadingVIP ? "div-_select-_btn_clicked":"div-_select-_btn"}
                  onClick={clickVIP}
                  // aria-hidden={isLoadingVIP ? "true" : "false"}
                  // inert={isLoadingVIP ? "true" : "false"}
                >
                  {isLoadingVIP ? <Loading type='bars' width={100} height={50} padding={3} fill='#ffffff' /> : <div className="choose-business">{vipBtnTitle}</div>}
                </button>
                <div className="div-_feature-_list">
                  {vip1.map((feature, index) => (
                    <div key={index} className="div-_featureitem">
                      <img
                        src={blackcheck}
                        alt="Feature Icon"
                        className={`icon-`}
                      />
                      <p className={`feature-text-`}>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
              {/* <div className="div-_listitem">
                <p className="Text">BUSINESS</p>
                <div className="div-_price1">
                  <p className="price">{isAnnualBilling ? `$${VIP2AnnualPrice}` : `$${VIP2MonthlyPrice}`}</p>
                  {isAnnualBilling ? (
                    <div>
                      <div className="div-_unit">
                        <div className="span-_cut">
                          <p className="discont">{`$${VIP2MonthlyPrice}`}</p>
                        </div>
                      </div>
                      <p className="mo">/mo</p>
                    </div>
                  ) : (
                    <p className="mo">/mo</p>
                  )}
                </div>

                <button
                  className= {isLoadingBusiness ? "div-_select-_btn_clicked":"div-_select-_btn"}
                  onClick={clickBusiness}
                >
                  {isLoadingBusiness ? <Loading type='bars' width={100} height={50} padding={3}  fill='#ffffff' /> : <div className="choose-business">Choose Business</div>}
                </button>
                <div className="div-_feature-_list">
                  {vip2.map((feature, index) => (
                    <div key={index} className="div-_featureitem">
                      <img
                        src={blackcheck}
                        alt="Feature Icon"
                        className={`icon-`}
                      />
                      <p className={`feature-text-`}>{feature}</p>
                    </div>
                  ))}
                </div>
              </div> */}
            </div>
          </div>   
        </div>

        <ConfirmDialog
          open={isConfirmDialogOpen}
          onClose={handleConfirmClose}
          onConfirm={handleConfirm}
          message={confirmMessage}
         />

        {/* <div className="popup-settingsnew-footer">
          <button className="cancel-button-price" onClick={onClose}>Close</button>
        </div> */}

      </div>
    </div>
  );
};

export default PricePopup;